/* eslint-disable promise/prefer-await-to-then */
import { DetailsList, DetailsListLayoutMode, Dialog, DialogContent, IColumn, IconButton, MessageBar, MessageBarType, ProgressIndicator, SelectionMode, Stack, TooltipHost } from "@fluentui/react"
import { useState } from "react"
import { useApiCall } from "../../hooks/apiHooks"

export function HouseholdMemberNotes() {
	const queryParameters = new URLSearchParams(window.top.location.search)
	const houseHoldMemberIdQueryParam = queryParameters.get("id")

	const [selectedNote, setSelectedNote] = useState<any>(undefined)

	const {
		data: notesData,
		loading: loadingNotesData,
		error: errorNotesData
	} = useApiCall<any>(`/getHouseholdMemberNotes?householdMemberId=${houseHoldMemberIdQueryParam}`, {
		refetchOnChanges: [houseHoldMemberIdQueryParam],
		canFetch: !!houseHoldMemberIdQueryParam
	})

	const getColumns = (): IColumn[] => [
		{
			key: "icon",
			name: "",
			isIconOnly: true,
			minWidth: 32,
			onRender: item => (
				<IconButton styles={{ root: { marginTop: -7 } }} iconProps={{ iconName: "DietPlanNotebook" }} onClick={() => setSelectedNote(item)} ariaLabel="View note" title="View note" />
			)
		},
		{
			key: "external_auth",
			name: "Call Ref. #",
			fieldName: "external_auth",
			minWidth: 80
		},
		{
			key: "caller_name",
			name: "Caller",
			fieldName: "caller_name",
			minWidth: 100
		},
		{
			key: "caller_phone",
			name: "Caller Phone",
			fieldName: "caller_phone",
			minWidth: 100
		},
		{
			key: "original_date",
			name: "Date",
			fieldName: "original_date",
			minWidth: 110
		},
		{
			key: "original_name",
			name: "CX Agent",
			fieldName: "original_name",
			minWidth: 130
		},
		{
			key: "member_alt_id",
			name: "Member ID",
			fieldName: "member_alt_id",
			minWidth: 90
		},
		// {
		// 	key: "call_type_1",
		// 	name: "Call Type",
		// 	fieldName: "call_type_1",
		// 	minWidth: 60,
		// },
		{
			key: "pat_last_name",
			name: "Patient Last Name",
			fieldName: "pat_last_name",
			minWidth: 120
		},
		{
			key: "pat_first_name",
			name: "Patient First Name",
			fieldName: "pat_first_name",
			minWidth: 120
		},
		{
			key: "note_text",
			name: "Note",
			fieldName: "note_text",
			minWidth: 100,
			onRender: item => (
				<TooltipHost content={item.note_text} calloutProps={{ gapSpace: 0 }}>
					{item.note_text}
				</TooltipHost>
			)
		}
	]

	return (
		<Stack>
			{loadingNotesData && <ProgressIndicator label="Loading notes..." />}
			{errorNotesData && <MessageBar messageBarType={MessageBarType.error}>Error loading report data: {errorNotesData.message}</MessageBar>}
			{notesData && notesData.length > 0 && <DetailsList items={notesData} columns={getColumns()} selectionMode={SelectionMode.none} layoutMode={DetailsListLayoutMode.fixedColumns} />}
			{notesData && notesData.length === 0 && <MessageBar messageBarType={MessageBarType.info}>No notes available for this household member.</MessageBar>}
			{selectedNote && (
				<Dialog
					hidden={selectedNote === undefined}
					modalProps={{
						isBlocking: true
					}}
					minWidth={600}
					onDismiss={() => setSelectedNote(undefined)}
					dialogContentProps={{ title: "Note" }}>
					<DialogContent styles={{ inner: { padding: "0px 24px 6px" }, header: { display: "none" } }}>{selectedNote.note_text}</DialogContent>
				</Dialog>
			)}
		</Stack>
	)
}
